import { Image } from "antd";
import { useState } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";

function Login(props) {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [mobilefield, setMobilefield] = useState("");
  let errorsObj = { email: "", password: "" };
  let mobilefieldErrorObj = { mobilefield: "" };
  const [errors, setErrors] = useState(errorsObj);
  const [otpErrors, setOtpErrors] = useState(mobilefieldErrorObj);
  const [password, setPassword] = useState("");
  const [loginToggle, setLoginToggle] = useState("password");

  const [isLoading, setLoading] = useState(false);
  const [isMobileLoading, setMobileLoading] = useState(false);

  const toastConfig = {
    autoClose: 3000,
    closeButton: false,
    hideProgressBar: true,
  };

  function onAgentEmailLogin(e) {
    e.preventDefault();
    setLoading(true);
    let error = false;
    const errorObj = { ...errorsObj };
    if (email === "") {
      toast.error("Email is Required", toastConfig);
      setLoading(false);
      error = true;
    }
    if (password === "") {
      toast.error("Password is Required", toastConfig);
      setLoading(false);
      error = true;
    }
    setErrors(errorObj);
    if (error) {
      return;
    }

    let data = {
      email_address: email?.toLowerCase(),
      password: password,
    };
    console.log({ data });

    props.apis
      .apiAgentLoginViaEmail(data)
      .then((res) => {
        console.log({ apiAgentLoginViaEmail: res });
        props.store("logged", res.logged);
        props.store("loggedIn", new Date().getTime());
        props.store("auth", res.auth);
        props.store("user", res.user);
        props.store("persona", _enum.ROUTE_PERSONAS.agent);

        navigate("/app/agentapplications");
        setLoading(false);
      })
      .catch((err) => {
        console.log({ Emaillogin: err });
        setLoading(false);
        swal2.fire({
          title: "Unauthorized",
          text: `${err?.response?.data?.message || "Login Failed"}`,
          icon: "error",
          iconColor: "#FF4D4D",
          showCancelButton: false,
        });
      });
  }

  function onAgentOtpLogin(e) {
    e.preventDefault();
    let error = false;
    const errorObj = { ...mobilefieldErrorObj };
    var mobilePattern = /^\d{10}$/;

    if (mobilefield === "") {
      toast.error("Mobile Number is Required", toastConfig);
      error = true;
    } else if (!mobilePattern.test(mobilefield)) {
      toast.error("Invalid Mobile Number", toastConfig);
      error = true;
    } else {
      setMobileLoading(true);
    }
    setOtpErrors(errorObj);
    if (error) {
      return;
    }
    let data = {
      mobile_number: mobilefield,
    };
    console.log({ data });

    props.apis
      .apiAgentLoginRequestViaOtp(data)
      .then((res) => {
        props.store("agentLoginMobileNumber", mobilefield);
        navigate("/open/agent/loginverify");
        setMobileLoading(false);
      })
      .catch((err) => {
        console.log({ OTPlogin: err });
        const errorObj = { ...errorsObj };
        errorObj.mobilefield = "login failed";

        setOtpErrors(errorObj);
        setMobileLoading(false);

        swal2
          .fire({
            title:
              "This mobile no. is not registered yet . Please click here for registration",
            icon: "info",
            iconColor: "#234C9B",
            showCancelButton: false,
            confirmButtonText: "Register Now",
          })
          .then((result) => {
            // if (result.isConfirmed) {
            //   // Redirect to register page and auto trigger otp
            //   let payload = {
            //     mobile_number: mobilefield,
            //   };
            //   props.apis
            //     .apiConnectorSignUpRequest(payload)
            //     .then((res) => {
            //       console.log({ apiConnectorSignUpRequest: res });
            //       props.store("connectorSignUpMobileNumber", mobilefield);
            //       navigate("/open/connector/signupverify");
            //       setMobileLoading(false);
            //     })
            //     .catch((err) => {
            //       console.log({ OTPlogin: err });
            //       const errorObj = { ...errorsObj };
            //       errorObj.mobilefield = "Signup failed";
            //       setOtpErrors(errorObj);
            //       setMobileLoading(false);
            //     });
            // }
          });
      });
  }

  const handleLoginToggle = (val) => {
    setLoginToggle(val);
  };

  const toggleSwitchPassword = () => {
    const passwordField = document.querySelector("#password");
    const togglePassword = document.querySelector("#togglePassword");

    togglePassword.addEventListener("click", function () {
      if (passwordField.type === "password") {
        passwordField.type = "text";
        togglePassword.classList.remove("fa-eye");
        togglePassword.classList.add("fa-eye-slash");
      } else {
        passwordField.type = "password";
        togglePassword.classList.remove("fa-eye-slash");
        togglePassword.classList.add("fa-eye");
      }
    });
  };

  props.$setNode({
    props,
  });

  return (
    <>
      <ToastContainer />
      <div className="page-wraper">
        <div className="browse-job login-style3">
          <div className="bg-img-fix overflow-hidden">
            <div className="parent-container row gx-0">
              <div
                className="col-xl-6 col-lg-6 col-md-6 col-sm-12 login_img_bg"
                style={{ backgroundImage: "url(" + imagepaths.loginBg + ")" }}
              >
                <div className="logo_header ps-3">
                  <Link to={"/open/agent/login"} className="logo">
                    <img src={imagepaths.logoWithTagline} alt="" />
                  </Link>
                </div>
              </div>
              <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12 d-flex align-items-center">
                <div className="login-form style-2 py-4">
                  <div className="card-body">
                    <div className="nav nav-tabs border-bottom-0">
                      <div className="tab-content w-100" id="nav-tabContent">
                        <div
                          className="tab-pane fade active show"
                          id="nav-personal"
                        >
                          {props.errorMessage && (
                            <div className="bg-red-300 text-red-900 border border-red-900 p-1 my-2">
                              {props.errorMessage}
                            </div>
                          )}
                          {props.successMessage && (
                            <div className="bg-green-300 text-green-900 border border-green-900 p-1 my-2">
                              {props.successMessage}
                            </div>
                          )}
                          <div className="w-100 text-center">
                            <Image
                              src={imagepaths.logoHome}
                              preview={false}
                              width={150}
                              className="mb-4 pointer-cursor"
                              alt="logo"
                              onClick={() => navigate("/open/connector/login")}
                            />
                          </div>
                          <h3 className="form-title m-t0 text-center">
                            Welcome to Wealth Avenue
                          </h3>
                          <div className="dz-separator-outer m-b5">
                            <div className="dz-separator bg-primary style-liner"></div>
                          </div>
                          <p className="sub-title text-center">
                            Access to explore more
                          </p>

                          <div className="login_toggle_container my-4">
                            <button
                              type="button"
                              onClick={() => handleLoginToggle("password")}
                              className={
                                loginToggle === "password"
                                  ? "btn active"
                                  : "btn"
                              }
                            >
                              Password
                            </button>
                            <button
                              type="button"
                              onClick={() => handleLoginToggle("mobilefield")}
                              className={
                                loginToggle === "mobilefield"
                                  ? "btn active"
                                  : "btn"
                              }
                            >
                              OTP
                            </button>
                          </div>
                          <div>
                            {loginToggle === "password" && (
                              <form
                                className=" dz-form pb-3"
                                onSubmit={!isLoading ? onAgentEmailLogin : null}
                              >
                                <div className="form-group mb-3">
                                  <label>Email</label>
                                  <input
                                    type="email"
                                    className="form-control"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    placeholder="Please Enter"
                                  />
                                  {errors.email && (
                                    <div className="text-danger fs-12">
                                      {errors.email}
                                    </div>
                                  )}
                                </div>
                                <div className="password-container form-group mb-3">
                                  <label>Password</label>
                                  <input
                                    type="password"
                                    id="password"
                                    className="form-control"
                                    value={password}
                                    onChange={(e) =>
                                      setPassword(e.target.value)
                                    }
                                    placeholder="Please Enter"
                                  />
                                  <i
                                    className="far fa-eye"
                                    id="togglePassword"
                                    onMouseEnter={() => toggleSwitchPassword()}
                                  ></i>
                                  {errors.password && (
                                    <div className="text-danger fs-12">
                                      {errors.password}
                                    </div>
                                  )}
                                </div>
                                <div className="form-group mb-5 d-flex align-items-start justify-content-between">
                                  <span className="form-check d-inline-block ms-2">
                                    <input
                                      type="checkbox"
                                      className="form-check-input"
                                      id="check1"
                                      name="example1"
                                    />
                                    <label
                                      className="form-check-label"
                                      htmlFor="check1"
                                    >
                                      Remember me
                                    </label>
                                  </span>
                                  <span>
                                    <NavLink
                                      to="/open/agent/forgetpassword"
                                      className="ms-auto"
                                    >
                                      Forgot Password ?
                                    </NavLink>
                                  </span>
                                </div>
                                <div
                                  className={Object.className({
                                    "form-group text-left": true,
                                    "not-allowed": true,
                                  })}
                                >
                                  <button
                                    type="submit"
                                    className="btn btn-primary button-md btn-block"
                                    disabled={isLoading}
                                  >
                                    {isLoading ? "Loading…" : "login"}
                                  </button>
                                </div>
                              </form>
                            )}
                          </div>
                          <div>
                            {loginToggle === "mobilefield" && (
                              <form
                                className=" dz-form pb-3"
                                onSubmit={onAgentOtpLogin}
                              >
                                <div className="form-group my-4">
                                  <label htmlFor="">Mobile no.</label>
                                  <div className="position-relative">
                                    <input
                                      type="text"
                                      onChange={(e) =>
                                        setMobilefield(e.target.value)
                                      }
                                      className="form-control"
                                      placeholder="Please Enter"
                                    />
                                    <img
                                      className="user-icon"
                                      src={imagepaths.InputUserIcon}
                                      alt="user icon"
                                    />

                                    {otpErrors.mobilefield && (
                                      <div className="text-danger fs-12">
                                        {otpErrors.mobilefield}
                                      </div>
                                    )}
                                  </div>
                                </div>
                                <div
                                  className={Object.className({
                                    "form-group text-left": true,
                                    "not-allowed": true,
                                  })}
                                >
                                  <button
                                    type="submit"
                                    className="btn btn-primary button-md btn-block"
                                    disabled={isMobileLoading}
                                  >
                                    {isMobileLoading ? "Loading…" : "Send OTP"}
                                  </button>
                                </div>

                                {/* <div className="text-center bottom mt-4">
                                  <span>Not a member? Click here to </span>
                                  <NavLink
                                    to="/open/connector/signup"
                                    className="text-primary fw-bold"
                                  >
                                    Register
                                  </NavLink>
                                </div> */}
                              </form>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
export default constore(Login);
